import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, LibracaoCiliState } from './types';

export const INITIAL_STATE: LibracaoCiliState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): LibracaoCiliState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.LIBERACAO_CILI_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.LIBERACAO_CILI_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}

			case Types.LIBERACAO_CILI_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.LIBERACAO_CILI_CLEAR: {
				draft.status = 0;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
